import {
  SSO_REGISTER_CONTEXT_COOKIE,
  type SsoRegisterContext,
} from "@/_constants/sso";

const COOKIE_MAX_AGE_SEC = 600;

export function setSsoRegisterContext(context: SsoRegisterContext) {
  const value = encodeURIComponent(JSON.stringify(context));
  document.cookie = `${SSO_REGISTER_CONTEXT_COOKIE}=${value}; path=/; max-age=${COOKIE_MAX_AGE_SEC}; SameSite=Lax`;
}

export function clearSsoRegisterContext() {
  document.cookie = `${SSO_REGISTER_CONTEXT_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
}
